import type { ReactNode } from "react";
import { Header } from "./header/Header";

export interface LayoutProps {
    children: ReactNode;
}

/** 管理后台整体布局，承接旧版 Header + 内容区的固定层级。 */
export function Layout({ children }: LayoutProps) {
    return (
        <div className="layout-root">
            <Header />
            {children}
        </div>
    );
}

export default Layout;
